import { Result } from '../components/kiosk/IndividualKioskResultsContent'

export default function hasNoResult(result: Result): boolean {
  return !result.intervals?.length
}
